/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const fieldTokens = {
  ContainerWidthBaseDefault: '580px',
  ContainerSpacingVerticalBaseDefault: '20px',
  LabelFontColorBaseDefault: '#1c2222',
  LabelFontSizeBaseDefault: '14px',
  LabelFontWeightBaseDefault: '500',
  LabelFontLeadingBaseDefault: '24px',
  RequiredFontColorBaseDefault: '#e14963',
  RequiredFontWeightBaseDefault: '300',
  RequiredFontSizeBaseDefault: '22px',
  RequiredGraphicGlyphDefault: '*',
  InfoBackgroundColorBaseDefault: '#eaf0f8',
  InfoBorderRadiusBaseDefault: '4px',
  InfoFontColorBaseDefault: '#1c2222',
  InfoFontSizeBaseDefault: '12px',
  InfoFontWeightBaseDefault: '400',
  InfoFontLeadingBaseDefault: '20px',
  InfoSpacingHorizontalBaseDefault: '4px',
} as const;
